import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { Button, Form, message, Modal } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import ModalHeaderText from "../../common/ModalHeaders/ModalHeaderText";
import { logout } from "../../redux/Auth/authActions";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import UiButton from "../Common/UiButton/UiButton";
import "./style.css";

import { logoutSuccess } from "./../../redux/Auth/authActions";
import { setLogoutFlag } from "./../../redux/logout/action";

function CustomLogout(props) {
  const dispatch = useDispatch();

  const state = useSelector((state) => state);

  const [form] = Form.useForm();
  const { logoutFlag } = state.Logout;
  const { access_token, expires_in, refresh_token } =
    state.auth.loginCredentials?.data?.dto?.accessToken || {};

  const [modalInfo, setModalInfo] = useState({
    visible: false,
    message: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(true);
  const navigate = useNavigate();
  // const showModal = () => {
  //   setIsModalOpen(true);
  // };
  const handleOk = () => {
    props.logout("Nothing");
    setIsModalOpen(false);
    navigate("/");
    props.setLogoutFlag();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const handleEnterKeyPress = (e) => {
      if (e.key === 'Enter') {
        form.submit();
      }
    };

    if (isModalOpen) {
      window.addEventListener('keydown', handleEnterKeyPress);
    } else {
      window.removeEventListener('keydown', handleEnterKeyPress);
    }

    return () => {
      window.removeEventListener('keydown', handleEnterKeyPress);
    };
  }, [isModalOpen, form]);


  useEffect(() => {
    const handleEnterKeyPress = (e) => {
      if (e.key === 'Enter') {
        setModalInfo((prevModalInfo) => ({
          ...prevModalInfo,
          visible: false,
        }))
      }
    };

    if (modalInfo) {
      window.addEventListener('keydown', handleEnterKeyPress);
    } else {
      window.removeEventListener('keydown', handleEnterKeyPress);
    }

    return () => {
      window.removeEventListener('keydown', handleEnterKeyPress);
    };
  }, [modalInfo, form]);


  useEffect(() => {
    let modalTimer;
    if (access_token) {
      const alertTime = 30 * 60 * 1000; //How much time earlier alert should be shown 10 min in milliseconds
      const currentTime = new Date();
      const accessTokenExpiryTime = new Date();
      accessTokenExpiryTime.setUTCSeconds(expires_in);
      const showPopUptime =
        accessTokenExpiryTime.getTime() - currentTime.getTime() - alertTime;
      const message = `Your session will expire in ${parseInt(
        alertTime / 60000,
        10
      )} minutes`;
      setModalInfo((prevModalInfo) => ({ ...prevModalInfo, message: message }));
      if (
        accessTokenExpiryTime.getTime() > currentTime.getTime() ||
        showPopUptime > 0
      ) {
        modalTimer = setTimeout(() => {
          setModalInfo((prevModalInfo) => ({
            ...prevModalInfo,
            visible: true,
          }));
        }, showPopUptime);
      }
    }
    return () => {
      clearTimeout(modalTimer);
    };
  }, [expires_in, refresh_token]);
  if (logoutFlag) {
    return (
      <div>

        {" "}
        <Modal
          open={isModalOpen}
          closable={false}
          className="modal-container"
          centered
          footer={null}
          zIndex={9999999}
        >
          <Form
            autoComplete="off"
            name="logout"
            className="change-password"
            form={form}
            onFinish={handleOk}

          >

            <Row>
              <Col lg={12} xs={12} md={12} sm={12}>
                <Col md={12}>
                  {/* <InfoCircleOutlined
                  style={{ color: "#1890ff", fontSize: 24, marginRight: 20 }}
                /> */}
                  {/* <span style={{ fontSize: 16 }}>Session Expired!</span> */}
                  <ModalHeaderText LoginHeading="Logout" />
                </Col>
              </Col>
            </Row>
            <Row>
              <Col lg={12} xs={12} md={12} sm={12}>
                <div
                  style={{
                    margin: "30px 0px 5px 0px",
                  }}
                >
                  You have been logged out.
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={12} className="d-flex justify-content-end mt-4">
                {/* <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button> */}
                <Button className="" htmlType="submit" type="primary">
                  Ok
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>


      </div>
    );
  } else {
    return (
      <Modal
        closable={false} open={modalInfo.visible} footer={null}
        zIndex={9999999}

      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <InfoCircleOutlined
              style={{ color: "#1890ff", fontSize: 24, marginRight: 20 }}
            />
            <span style={{ fontSize: 16 }}>Session Alert!</span>
          </div>
          <div
            style={{
              margin: "10px 0px 5px 45px",
            }}
          >
            {modalInfo.message}
          </div>
          <UiButton
            className="contine-btn"
            type="button"
            title="Continue"
            style={{ alignSelf: "end" }}
            onClick={() =>
              setModalInfo((prevModalInfo) => ({
                ...prevModalInfo,
                visible: false,
              }))
            }
          ></UiButton>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (user) => dispatch(logoutSuccess(user)),
    setLogoutFlag: (user) => dispatch(setLogoutFlag(user)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomLogout);
